export default __webpack_public_path__ + "static/media/736.e7cecda4.gif";